<template>
  <b-card no-body>
    <b-card-header class="text-center">Summary</b-card-header>
    <b-list-group flush>
      <b-list-group-item>
        <h6>Reddit Username</h6>
        {{ `u/${input.username.value}` }}
      </b-list-group-item>
      <b-list-group-item>
        <h6>Team</h6>
        {{ input.team.value }}
      </b-list-group-item>
      <b-list-group-item>
        <h6>Body</h6>
        {{ input['Body'].paint.value + ' ' + input['Body'].item.value }}
      </b-list-group-item>
      <b-list-group-item>
        <h6>Decal</h6>
        {{ input['Decal'].paint.value + ' ' + input['Decal'].item.value }}
      </b-list-group-item>
      <b-list-group-item>
        <h6>Primary Paint Finish</h6>
        <div class="team-colors">
          <div :class="input.team.value">
            <div class="color-preview rounded mb-1" :class="input['Paint Finish'].primary.color.value"></div>
          </div>
        </div>
        {{ input['Paint Finish'].primary.item.value }}
      </b-list-group-item>
      <b-list-group-item>
        <h6>Accent Paint Finish</h6>
        <div class="team-colors">
          <div class="Accent">
            <div class="color-preview rounded mb-1" :class="input['Paint Finish'].accent.color.value"></div>
          </div>
        </div>
        {{ input['Paint Finish'].accent.item.value }}
      </b-list-group-item>
      <b-list-group-item>
        <h6>Wheels</h6>
        {{ input['Wheels'].paint.value + ' ' + input['Wheels'].item.value }}
      </b-list-group-item>
      <b-list-group-item>
        <h6>Boost</h6>
        {{ input['Rocket Boost'].paint.value + ' ' + input['Rocket Boost'].item.value }}
      </b-list-group-item>
      <b-list-group-item>
        <h6>Topper</h6>
        {{ input['Topper'].paint.value + ' ' + input['Topper'].item.value }}
      </b-list-group-item>
      <b-list-group-item>
        <h6>Antenna</h6>
        {{ input['Antenna'].paint.value + ' ' + input['Antenna'].item.value }}
      </b-list-group-item>
      <b-list-group-item>
        <h6>Trail</h6>
        {{ input['Trail'].paint.value + ' ' + input['Trail'].item.value }}
      </b-list-group-item>
      <b-list-group-item>
        <h6>Goal Explosion</h6>
        {{ input['Goal Explosion'].paint.value + ' ' + input['Goal Explosion'].item.value }}
      </b-list-group-item>
      <b-list-group-item>
        <h6>Map</h6>
        {{ input.map.value }}
      </b-list-group-item>
      <b-list-group-item>
        <h6>Rotate Car 360º</h6>
        {{ input.rotate.value }}
      </b-list-group-item>
    </b-list-group>
  </b-card>
</template>

<script>
export default {
  name: 'Summary',
  props: {
    input: Object
  }
}
</script>

<style scoped>
.color-preview {
  height: 2em;
}
</style>